export enum ScreenNameErrorCode {
  Duplicate = 'screen-name-already-exists-error',
  ProfanityFilter = 'screen-name-did-not-pass-profanity-error',
}

export type ScreenNameErrorMap = Record<ScreenNameErrorCode, string>;
